import { render, staticRenderFns } from "./vue-swipe-component.vue?vue&type=template&id=ac60824e&scoped=true&"
import script from "./vue-swipe-component.vue?vue&type=script&lang=js&"
export * from "./vue-swipe-component.vue?vue&type=script&lang=js&"
import style0 from "./vue-swipe-component.vue?vue&type=style&index=0&id=ac60824e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac60824e",
  null
  
)

export default component.exports